import { Chess } from 'chess.js';

export type SquareId = string;

const FILES = ['a','b','c','d','e','f','g','h'];
const RANKS = ['8','7','6','5','4','3','2','1'];

// cburnett / Wikipedia-style SVG pieces (viewBox 0 0 45 45)
const PIECE_SVG: Record<string, string> = {
  wK: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 22.5,11.63 L 22.5,6" stroke-linejoin="miter"/>
      <path d="M 20,8 L 25,8" stroke-linejoin="miter"/>
      <path d="M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25" fill="#fff" stroke-linecap="butt" stroke-linejoin="miter"/>
      <path d="M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37" fill="#fff"/>
      <path d="M 12.5,30 C 18,27 27,27 32.5,30"/>
      <path d="M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5"/>
      <path d="M 12.5,37 C 18,34 27,34 32.5,37"/>
    </g>
  </svg>`,

  wQ: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z" fill="#fff" stroke-linecap="butt"/>
      <path d="M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 11,36 11,36 C 9.5,37.5 11.5,38.5 11.5,38.5 C 17.5,39.5 27.5,39.5 33.5,38.5 C 33.5,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z" fill="#fff"/>
      <path d="M 11.5,30 C 15,29 30,29 33.5,30" fill="none"/>
      <path d="M 12,33.5 C 15,32.5 30,32.5 33,33.5" fill="none"/>
      <circle cx="6" cy="12" r="2" fill="#fff"/>
      <circle cx="14" cy="9" r="2" fill="#fff"/>
      <circle cx="22.5" cy="8" r="2" fill="#fff"/>
      <circle cx="31" cy="9" r="2" fill="#fff"/>
      <circle cx="39" cy="12" r="2" fill="#fff"/>
    </g>
  </svg>`,

  wR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="#fff" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z" stroke-linecap="butt"/>
      <path d="M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z" stroke-linecap="butt"/>
      <path d="M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14" stroke-linecap="butt"/>
      <path d="M 34,14 L 31,17 L 14,17 L 11,14"/>
      <path d="M 31,17 L 31,29.5 L 14,29.5 L 14,17"/>
      <path d="M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5"/>
      <path d="M 11,14 C 11,12 14,11 14,11 L 31,11 C 31,11 34,12 34,14" fill="none" stroke-linejoin="miter"/>
    </g>
  </svg>`,

  wB: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z" fill="#fff"/>
      <path d="M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 L 22.5,10 L 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z" fill="#fff"/>
      <path d="M 25,8 A 2.5,2.5 0 1 1 20,8 A 2.5,2.5 0 1 1 25,8 z" fill="#fff"/>
      <path d="M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18" stroke-linejoin="miter"/>
    </g>
  </svg>`,

  wN: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18" fill="#fff"/>
      <path d="M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10" fill="#fff"/>
      <path d="M 9.5,25.5 A 0.5,0.5 0 1 1 8.5,25.5 A 0.5,0.5 0 1 1 9.5,25.5 z" fill="#000"/>
      <path d="M 15,15.5 A 0.5,1.5 0 1 1 14,15.5 A 0.5,1.5 0 1 1 15,15.5 z" fill="#000" transform="matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)"/>
    </g>
  </svg>`,

  wP: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M 22,9 C 19.79,9 18,10.79 18,13 C 18,13.89 18.29,14.71 18.78,15.38 C 16.83,16.5 15.5,18.59 15.5,21 C 15.5,23.03 16.44,24.84 17.91,26.03 C 14.91,27.09 10.5,31.58 10.5,39.5 L 33.5,39.5 C 33.5,31.58 29.09,27.09 26.09,26.03 C 27.56,24.84 28.5,23.03 28.5,21 C 28.5,18.59 27.17,16.5 25.22,15.38 C 25.71,14.71 26,13.89 26,13 C 26,10.79 24.21,9 22,9 z" fill="#fff" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
  </svg>`,

  bK: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 22.5,11.63 L 22.5,6" stroke="#fff" stroke-linejoin="miter"/>
      <path d="M 20,8 L 25,8" stroke="#fff" stroke-linejoin="miter"/>
      <path d="M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25" fill="#000" stroke-linecap="butt" stroke-linejoin="miter"/>
      <path d="M 12.5,37 C 18,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 20,16 10.5,13 6.5,19.5 C 3.5,25.5 12.5,30 12.5,30 L 12.5,37" fill="#000"/>
      <path d="M 12.5,30 C 18,27 27,27 32.5,30" stroke="#fff"/>
      <path d="M 12.5,33.5 C 18,30.5 27,30.5 32.5,33.5" stroke="#fff"/>
      <path d="M 12.5,37 C 18,34 27,34 32.5,37" stroke="#fff"/>
    </g>
  </svg>`,

  bQ: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z" fill="#000" stroke-linecap="butt"/>
      <path d="M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 11,36 11,36 C 9.5,37.5 11.5,38.5 11.5,38.5 C 17.5,39.5 27.5,39.5 33.5,38.5 C 33.5,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z" fill="#000"/>
      <path d="M 11.5,30 C 15,29 30,29 33.5,30" stroke="#fff"/>
      <path d="M 12,33.5 C 15,32.5 30,32.5 33,33.5" stroke="#fff"/>
      <circle cx="6" cy="12" r="2" fill="#000"/>
      <circle cx="14" cy="9" r="2" fill="#000"/>
      <circle cx="22.5" cy="8" r="2" fill="#000"/>
      <circle cx="31" cy="9" r="2" fill="#000"/>
      <circle cx="39" cy="12" r="2" fill="#000"/>
    </g>
  </svg>`,

  bR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="#000" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z" stroke-linecap="butt"/>
      <path d="M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z" stroke-linecap="butt"/>
      <path d="M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14" stroke-linecap="butt"/>
      <path d="M 34,14 L 31,17 L 14,17 L 11,14"/>
      <path d="M 31,17 L 31,29.5 L 14,29.5 L 14,17"/>
      <path d="M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5"/>
      <path d="M 11,14 C 11,12 14,11 14,11 L 31,11 C 31,11 34,12 34,14" fill="none" stroke-linejoin="miter"/>
      <path d="M 12,35.5 L 33,35.5" stroke="#fff" stroke-width="1"/>
      <path d="M 13,31.5 L 32,31.5" stroke="#fff" stroke-width="1"/>
    </g>
  </svg>`,

  bB: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.65,38.99 6.68,38.97 6,38 C 7.35,36.54 9,36 9,36 z" fill="#000"/>
      <path d="M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 L 22.5,10 L 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z" fill="#000"/>
      <path d="M 25,8 A 2.5,2.5 0 1 1 20,8 A 2.5,2.5 0 1 1 25,8 z" fill="#000"/>
      <path d="M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18" stroke="#fff" stroke-linejoin="miter"/>
    </g>
  </svg>`,

  bN: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18" fill="#000"/>
      <path d="M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10" fill="#000"/>
      <path d="M 9.5,25.5 A 0.5,0.5 0 1 1 8.5,25.5 A 0.5,0.5 0 1 1 9.5,25.5 z" fill="#fff"/>
      <path d="M 15,15.5 A 0.5,1.5 0 1 1 14,15.5 A 0.5,1.5 0 1 1 15,15.5 z" fill="#fff" transform="matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)"/>
    </g>
  </svg>`,

  bP: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M 22,9 C 19.79,9 18,10.79 18,13 C 18,13.89 18.29,14.71 18.78,15.38 C 16.83,16.5 15.5,18.59 15.5,21 C 15.5,23.03 16.44,24.84 17.91,26.03 C 14.91,27.09 10.5,31.58 10.5,39.5 L 33.5,39.5 C 33.5,31.58 29.09,27.09 26.09,26.03 C 27.56,24.84 28.5,23.03 28.5,21 C 28.5,18.59 27.17,16.5 25.22,15.38 C 25.71,14.71 26,13.89 26,13 C 26,10.79 24.21,9 22,9 z" fill="#000" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
  </svg>`,
};

const DRAG_THRESHOLD = 6; // pixels before drag mode activates

export class Board {
  private container: HTMLElement;
  private chess: Chess;
  private selected: SquareId | null = null;
  private highlights: Set<SquareId> = new Set();
  private lastMove: { from: SquareId; to: SquareId } | null = null;
  private onMove: (from: SquareId, to: SquareId) => void;
  private interactive: boolean = true;
  private flipped: boolean = false;

  // Drag state
  private dragFrom: SquareId | null = null;
  private dragGhost: HTMLElement | null = null;
  private dragStartX = 0;
  private dragStartY = 0;
  private isDragging = false;

  constructor(container: HTMLElement, onMove: (from: SquareId, to: SquareId) => void) {
    this.container = container;
    this.chess = new Chess();
    this.onMove = onMove;
    // Persistent pointer listeners on container (survive re-renders)
    this.container.addEventListener('pointerdown',   this.onPointerDown.bind(this));
    this.container.addEventListener('pointermove',   this.onPointerMove.bind(this));
    this.container.addEventListener('pointerup',     this.onPointerUp.bind(this));
    this.container.addEventListener('pointercancel', this.onPointerUp.bind(this));
    this.render();
  }

  getCurrentFen(): string {
    return this.chess.fen();
  }

  applyMoveOptimistically(from: SquareId, to: SquareId): { captured: boolean } | null {
    try {
      const move = this.chess.move({ from, to: to as any, promotion: 'q' });
      this.lastMove = { from, to };
      this.selected = null;
      this.highlights = new Set();
      this.interactive = false;
      this.render();
      return { captured: !!move.captured };
    } catch {
      return null;
    }
  }

  setFen(fen: string, interactive = true, flipped = false, lastMove: { from: SquareId; to: SquareId } | null = null): void {
    this.chess = new Chess(fen);
    this.selected = null;
    this.highlights = new Set();
    this.lastMove = lastMove;
    this.interactive = interactive;
    this.flipped = flipped;
    this.render();
  }

  setInteractive(interactive: boolean): void {
    this.interactive = interactive;
    this.selected = null;
    this.highlights = new Set();
    this.render();
  }

  private render(): void {
    this.container.innerHTML = '';
    this.container.className = 'board';

    const ranks = this.flipped ? [...RANKS].reverse() : RANKS;
    const files = this.flipped ? [...FILES].reverse() : FILES;

    for (const rank of ranks) {
      for (const file of files) {
        const sq = file + rank as SquareId;
        const fileIdx = FILES.indexOf(file);
        const rankIdx = RANKS.indexOf(rank);
        const isLight = (fileIdx + rankIdx) % 2 === 0;

        const cell = document.createElement('div');
        cell.className = 'square ' + (isLight ? 'light' : 'dark');
        if (this.lastMove && (sq === this.lastMove.from || sq === this.lastMove.to)) cell.classList.add('last-move');
        if (this.highlights.has(sq)) cell.classList.add('highlight');
        if (this.selected === sq) cell.classList.add('selected');
        cell.dataset.sq = sq;

        // Rank label on the left edge of the first file column
        if (file === files[0]) {
          const label = document.createElement('span');
          label.className = 'coord coord-rank';
          label.textContent = rank;
          cell.appendChild(label);
        }

        // File label on the bottom edge of the last rank row
        if (rank === ranks[ranks.length - 1]) {
          const label = document.createElement('span');
          label.className = 'coord coord-file';
          label.textContent = file;
          cell.appendChild(label);
        }

        const piece = this.chess.get(sq as any);
        if (piece) {
          const wrap = document.createElement('div');
          wrap.className = 'piece';
          wrap.innerHTML = PIECE_SVG[piece.color + piece.type.toUpperCase()] ?? '';
          cell.appendChild(wrap);
        }

        this.container.appendChild(cell);
      }
    }
  }

  // ── Pointer events (mouse + touch unified via Pointer Events API) ────────────

  private onPointerDown(e: PointerEvent): void {
    if (!this.interactive) return;
    const cell = (e.target as HTMLElement).closest<HTMLElement>('[data-sq]');
    if (!cell) return;
    e.preventDefault();
    this.container.setPointerCapture(e.pointerId);
    const sq = cell.dataset.sq as SquareId;
    this.dragFrom = sq;
    this.dragStartX = e.clientX;
    this.dragStartY = e.clientY;
    this.isDragging = false;
  }

  private onPointerMove(e: PointerEvent): void {
    if (!this.dragFrom) return;
    const dx = e.clientX - this.dragStartX;
    const dy = e.clientY - this.dragStartY;
    if (!this.isDragging && Math.hypot(dx, dy) > DRAG_THRESHOLD) {
      this.activateDrag(e.clientX, e.clientY);
    }
    if (this.dragGhost) {
      this.dragGhost.style.left = `${e.clientX}px`;
      this.dragGhost.style.top  = `${e.clientY}px`;
    }
  }

  private onPointerUp(e: PointerEvent): void {
    const from = this.dragFrom;
    const wasDragging = this.isDragging;
    this.dragGhost?.remove();
    this.dragGhost = null;
    this.dragFrom = null;
    this.isDragging = false;
    if (!from) return;

    if (wasDragging) {
      // Release capture so elementFromPoint works
      if (this.container.hasPointerCapture(e.pointerId)) {
        this.container.releasePointerCapture(e.pointerId);
      }
      if (this.dragGhost) this.dragGhost.style.display = 'none';
      const el = document.elementFromPoint(e.clientX, e.clientY);
      const targetCell = el?.closest<HTMLElement>('[data-sq]');
      const to = targetCell?.dataset.sq as SquareId | undefined;
      if (to && this.highlights.has(to)) {
        this.selected = null;
        this.highlights = new Set();
        this.onMove(from, to);
      } else {
        this.selected = null;
        this.highlights = new Set();
        this.render();
      }
    } else {
      this.handleClick(from);
    }
  }

  private activateDrag(clientX: number, clientY: number): void {
    if (!this.dragFrom || this.isDragging) return;
    const piece = this.chess.get(this.dragFrom as any);
    if (!piece || piece.color !== this.chess.turn()) return;
    this.isDragging = true;

    // Show legal moves
    this.selected = this.dragFrom;
    const moves = this.chess.moves({ square: this.dragFrom as any, verbose: true });
    this.highlights = new Set(moves.map((m) => m.to as SquareId));
    this.render();

    // Create ghost piece
    const cell = this.container.querySelector<HTMLElement>(`[data-sq="${this.dragFrom}"]`);
    const pieceEl = cell?.querySelector('.piece');
    if (!pieceEl) return;
    const rect = cell!.getBoundingClientRect();
    this.dragGhost = document.createElement('div');
    this.dragGhost.className = 'drag-ghost';
    this.dragGhost.innerHTML = pieceEl.innerHTML;
    this.dragGhost.style.cssText = `
      position: fixed;
      width: ${rect.width * 1.2}px;
      height: ${rect.height * 1.2}px;
      pointer-events: none;
      z-index: 9999;
      opacity: 0.92;
      transform: translate(-50%, -80%);
      left: ${clientX}px;
      top: ${clientY}px;
    `;
    document.body.appendChild(this.dragGhost);
  }

  // ── Click (fallback from drag) ────────────────────────────────────────────────

  private handleClick(sq: SquareId): void {
    if (this.selected) {
      if (this.highlights.has(sq)) {
        const from = this.selected;
        this.selected = null;
        this.highlights = new Set();
        this.onMove(from, sq);
        return;
      }
      this.selected = null;
      this.highlights = new Set();
    }

    const piece = this.chess.get(sq as any);
    if (piece && piece.color === this.chess.turn()) {
      this.selected = sq;
      const moves = this.chess.moves({ square: sq as any, verbose: true });
      this.highlights = new Set(moves.map((m) => m.to as SquareId));
    }
    this.render();
  }
}
